'use client';

import { Container } from 'react-bootstrap';

import { useTranslations } from 'next-intl';

import { useRelatedMovies } from '@/views/MovieDetailsView/RelatedMoviesView/useRelatedMovies';

import { MovieApi } from '@/api/domains/movie.api';

import { MovieCard } from '@/components/MovieCard';
import { MovieCardSkelton } from '@/components/MovieCard/MovieCardSkelton';
import { Slider } from '@/components/Slider';

import styles from '@/views/MovieDetailsView/RelatedMoviesView/RelatedMoviesView.module.scss';

export const RelatedMoviesView = () => {
  const t = useTranslations('common');

  const { movies, isLoading } = useRelatedMovies();

  return (
    <Container className="p-0">
      <Slider
        xs={2}
        sm={2}
        md={3}
        lg={4}
        xl={6}
        xxl={6}
        heading={t('related')}
        className={styles.movieRelatedSlider}
        slideClassName={styles.movieRelatedSlide}
      >
        {isLoading
          ? Array(6)
              .fill(null)
              .map((_, index) => <MovieCardSkelton key={index} />)
          : MovieApi.extractMoviesData(movies).map(movie => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
      </Slider>
    </Container>
  );
};
